







import { Component } from 'vue-property-decorator';
import UUIFComponents from '@/shared/uuifComponent';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import reCaptchaService from '@/services/reCaptcha.service';

@Component({
  components: {
    ...UUIFComponents,
  },
})

export default class RecaptchaV3Test extends SwExtendedVue {
  async created() {
    console.warn('recaptcha service: ', reCaptchaService);
    await reCaptchaService.initailizeV3Captcha();
    // await reCaptchaService.initailizeV2Captcha('recaptchaV2');
    // await reCaptchaService.renderReCaptch('recaptchaV2');
  }

  async mounted() {
    // await reCaptchaService.renderV3ReCaptch();
  }
}
